<template>
  <div class="pay">
    <div class="title">问问风湿患者平台</div>
    <div class="price">¥ {{ query.price }}</div>
    <div class="spline"></div>
    <div class="info">
      <div>收款方：</div>
      <div>问问风湿</div>
    </div>
    <div class="info">
      <div>项目：</div>
      <div>商城订单支付</div>
    </div>
    <div class="button" @click="submit">确认付款</div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import api_sale from '../../services/saleLogin.js';
import { Toast as VanToast } from 'vant';

export default {
  name: 'shop-pay',
  data() {
    return {
      query: {
        orderNumber: null,
        price: null,
      },
    };
  },

  mounted() {
    let { orderNumber, price } = this.$route.query;
    this.query.orderNumber = orderNumber;
    this.query.price = price;
  },
  methods: {
    async submit() {
      this.$indicator.open('支付中...');
      api_sale.shopOrderPay(this.query).then(
        (res) => {
          this.$indicator.close();
          if (res) {
            this.confirmPay(res);
            wx.closeWindow(); // 如果type = 1 关闭页面的方法 回到公众号
          } else {
            this.$toast('支付失败~');
          }
        },
        (err) => {
          this.$toast('支付失败~');
        }
      );
    },
    confirmPay(params) {
      if (window.WeixinJSBridge) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: params.appId,
            timeStamp: params.timeStamp,
            nonceStr: params.nonceStr,
            package: params.package,
            signType: 'MD5',
            paySign: params.paySign,
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              VanToast.success('支付成功！');
              this.$router.replace({
                path: '/shopping-order-list',
              });
              wx.closeWindow();
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              VanToast.success('支付失败！');
            }
          }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pay {
  margin: 0 15px;
  display: flex;
  flex-direction: column;
  text-align: center;
  .title {
    margin-top: 30px;
    font-size: 26px;
  }
  .price {
    margin-top: 10px;
    font-size: 22px;
  }
  .spline {
    margin: 10px 0;
    background: #f5f5f5;
    height: 2px;
  }
  .info {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
  }
  .button {
    margin: 20px 0;
    width: 100%;
    height: 40px;
    background: #208fe3;
    color: #ffffff;
    font-size: 22px;
    line-height: 40px;
    text-align: center;
  }
}
</style>
